<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#general" @click="activeComponent='brandList'" ><i class="fas fa-tasks"></i> Brands</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BrandList from './Tabs/BrandList'

export default {
  data () {
    return {
      activeComponent: 'brandList'
    }
  },
  components: {
    brandList: BrandList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompany/Content.vue